const paths = {
  root: '/',
  pupilDashLogin: '/login',
  pupilSurveys: '/surveys',
  surveyView: '/survey/:id',
  emailLogin: '/email-login',
  emailVerify: '/token-verification/:token',
  emailVerifyBase: '/token-verification',
  googleLogin: '/google-login',
  microsoftLogin: '/microsoft-login',
  qrCodeLogin: '/qr/:token',
  myLogin: '/mylogin',
  myLoginCallback: '/mylogin/callback',
  conversations: '/conversations',
  selectStaff: '/selectStaff',
  selectZone: '/select-zone',
  newConversation: '/new-conversation',
  startConversation: '/conversation',
  checkinQuestionaire: '/questionnaire',
  externalLoginUrl: '/auth/external-login',
  emojiLogin: '/e',
  advConversationSuccess:'/advConversationSuccess',
  simpleConversationSuccess:'/simpleConversationSuccess',
};

export const isAuthenticated = (state) => {
  if (!state || !state.auth) return false;
  
  if (!state.auth.user) return false;
  
  const { provider } = state.auth;
  
  if (provider === 'google' || provider === 'microsoft') {
    return Boolean(state.auth.isAuthenticated && state.auth.user);
  }
  
  if (provider === 'mylogin') {
    const accessToken = localStorage.getItem('mylogin_access_token');
    const expiresAt = localStorage.getItem('mylogin_expires_at');
    const isValid = accessToken && expiresAt && Number(expiresAt) > Date.now();
    
    return Boolean(state.auth.isAuthenticated && state.auth.user && isValid);
  }
  
  if (provider === 'email') {
    const pupilData = localStorage.getItem('pupil');
    return Boolean(state.auth.isAuthenticated && state.auth.user && pupilData);
  }
  
  return Boolean(state.auth.isAuthenticated && state.auth.user);
};

export default paths;
